import { CSSProperties } from 'react';
import { Box, Divider, Tab, Tabs } from '@material-ui/core';
import clsx from 'clsx';
import { ScrollButtonComponent } from './scroll-button-component';
import { useTabStyles } from './styles';

export type paddingType = 'small' | 'base' | 'medium' | 'xmedium' | 'large';

type Value = any;

export enum Type {
  squared = 'squared',
  rounded = 'rounded'
}

export type STab = {
  label: string;
  value: Value;
  disabled?: boolean;
  icon?: JSX.Element;
};

export interface TabsProps {
  currentTab: Value;
  tabsList: STab[];
  topDivider?: boolean;
  divider?: boolean;
  variant?: 'standard' | 'scrollable' | 'fullWidth';
  padding?: paddingType;
  type?: keyof typeof Type;
  scrollButtons?: 'auto' | 'on' | 'off' | 'desktop';
  tabStyle?: CSSProperties;
  activeTabStyle?: CSSProperties;
  handleTabChange: (value: Value) => void;
  newDesign?: boolean;
  containerStyle?: CSSProperties;
}

export const STabs = ({
  tabsList,
  currentTab = tabsList[0].value,
  topDivider = false,
  divider = true,
  padding = 'medium',
  variant = 'standard',
  type = Type.squared,
  tabStyle = {},
  activeTabStyle = {},
  scrollButtons = 'auto',
  handleTabChange,
  newDesign = false,
  containerStyle = {}
}: TabsProps) => {
  const classes = useTabStyles({ padding, type });

  return (
    <Box style={{ width: 'min-content' }}>
      {topDivider ? <Divider /> : null}
      <Tabs
        variant={variant}
        value={currentTab}
        scrollButtons={scrollButtons}
        style={{
          minHeight: 'auto',
          ...containerStyle
        }}
        classes={{
          indicator: classes.indicator,
          scrollButtons: classes.root,
          flexContainer: classes.flexContainer
        }}
        ScrollButtonComponent={props => {
          if (
            props.disabled &&
            (scrollButtons === 'auto' || scrollButtons === 'on')
          )
            return null;
          return (
            <ScrollButtonComponent
              onClick={props.onClick}
              direction={props.direction}
            />
          );
        }}
        onChange={(_, value) => handleTabChange(value)}
        TabIndicatorProps={{
          children: <span />,
          ...(newDesign ? { style: { display: 'none' } } : {})
        }}>
        {tabsList?.map(tab => (
          <Tab
            icon={tab.icon}
            key={tab.label}
            value={tab.value}
            label={tab.label}
            disabled={tab.disabled}
            style={{
              zIndex: 1,
              minHeight: 30,
              opacity: 1,
              ...(newDesign
                ? {
                    height: 40,
                    backgroundColor:
                      tab.value === currentTab ? '#1E96FC' : 'transparent',
                    color: tab.value === currentTab ? '#fff' : '#5D7083',
                    borderRadius: 120,
                    border: 'none',
                    transition: 'background-color 0.3s, color 0.1s'
                  }
                : {}),
              ...tabStyle,
              ...(tab.value === currentTab ? activeTabStyle : {})
            }}
            className={clsx(classes.tab, {
              [classes.activeTab]: currentTab === tab.value
            })}
          />
        ))}
      </Tabs>
      {divider ? <Divider /> : null}
    </Box>
  );
};
